import React, { useContext, useEffect } from "react";
import OrderContext from "../../../../context/OrderContext";
import Loader from "../../../Loader/Loader";
const ModalInvoces = () => {
  let {
    orderData,
    orderID,
    getOrderDataID,
    downloadInvloce,
    closeModal,
    loader,
  } = useContext(OrderContext);

  function invoceDownload(OrderID, InvoceId) {
    downloadInvloce(OrderID, InvoceId);
  }

  useEffect(() => {
    getOrderDataID(orderID);
  }, [orderID]);

  return (
    <>
      <div className="modal-header">
        <h4 className="modal-title">Invoices</h4>
        <button onClick={closeModal} className="btn btn-close">
          <i className="feather icon-x"></i>
        </button>
      </div>
      <div className="modal-content">
        <>
          <table className="table table-striped  nowrap">
            <thead>
              <tr>
                <th></th>
                <th>ID</th>
                <th>Pronted at</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {orderData.data?.invoices.map((item) => (
                <tr key={item.id}>
                  <td>
                    <i className="feather icon-file-text ml-2"></i>
                  </td>
                  <td className="product-info">{item.id}</td>
                  <td className="product-info">
                    {item.printedAt
                      ? item.printedAt.slice(0, 10)
                      : "Not printed"}
                  </td>
                  <td className="text-right">
                    <button
                      type="button"
                      className=" btn btn-outline-secondary"
                      onClick={() =>
                        invoceDownload(orderData.data.orderId, item.id)
                      }
                    >
                      Download
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      </div>
    </>
  );
};

export default ModalInvoces;
